<template>
  <!--:aria-valuenow="percentage"-->
  <div
    class="my-progress"
    aria-valuemin="0"
    aria-valuemax="100">
    <div class="my-progress" v-if="type === 'line'">
      <div class="progress-bar">
        <div class="progress-bar-outer">
          <div class="progress-bar-inner" :style='proportionWidth'></div>
        </div>
      </div>
      <div class="progress-text tip-bubble-top"
      :style='proportionLeft'>{{proportion.question_num}}/{{proportion.all_question_num}}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'myProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: val => ['line', 'circle'].indexOf(val) > -1
    },
    proportion: {}
  },
  computed: {
    proportionWidth () {
      return {
        width: this.proportion.question_num / this.proportion.all_question_num * 100 + '%'
      }
    },
    proportionLeft () {
      return {
        left: this.proportion.question_num / this.proportion.all_question_num * 100 + '%'
      }
    }
  },
  mounted () {
    console.log(this.proportionWidth)
  }
}
</script>

<style lang="scss" scoped> 
.progress-bar, .progress-bar-inner::after{
  display: inline-block;
  vertical-align: top;
}
.my-progress {
  position: relative;
  line-height: 1;
  .progress-bar {
    width: 100%;
    margin-right: -55px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    .progress-bar-outer{
      height: 8px;
      background: #E8F3FF;
      border-radius: 0px;
      overflow: hidden;
      position: relative;
      vertical-align: top;
      .progress-bar-inner{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        text-align: right;
        border-radius: 0px 10px 10px 0px;
        background-image: linear-gradient(0deg, #4E74FF 3%, #00B1FF 97%);
        line-height: 1;
        white-space: nowrap;
        -webkit-transition: width .6s ease;
        transition: width .6s ease;
      }
    }
  }
.progress-text{
    position: absolute;
    top: 23px;
    left: 70%;
    font-size: 14px;
    color: #606266;
    display: inline-block;
    vertical-align: middle;
    margin-left: -20px;
    line-height: 1;
  }
  .tip-bubble-top{
    padding: 3px 6px;
    background: #E8F3FF;
    border-radius: 5px;
    color: #45BCFF;
  }
  .tip-bubble-top:before{
    content: '';
    position: absolute;
    left: 50%;
    bottom: 100%;
    margin-left: -6px;
    width: 0;
    height: 0;
    border: 6px solid;
    border-bottom-color: #E8F3FF;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
  }
}

</style>
